import { Component, OnInit } from '@angular/core';
import { Event , NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'km-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

  constructor(private router: Router) { }

  toogledMenu: boolean;
  
  ngOnInit(): void {
  }

  toogleMenu(): void{
      this.toogledMenu = ! this.toogledMenu;
  }

}
